import Vue from 'vue';

import CommonComponents from './components/common/common-components';
import TiaraPlugin from './components/common/tiara-plugin';

import Ranking from './Ranking.vue';
import { store } from './store/ranking';

Vue.use(CommonComponents);
Vue.use(TiaraPlugin, { pageName: 'rank_cafe', pageNameDesc: '카페랭킹' });

new Vue({
	el: '#daumContent',
	store,
	render: h => h(Ranking)
});
